import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosTransferenciasListaItemComponent {
  admin
  data
  mostrar
  onSelect
  descripcion = ''

  $onChanges (changes) {
    if (changes.mostrar) {
      switch (this.mostrar) {
        case 'cuenta':
          this.descripcion = `Cuenta ${this.data.banco_cuenta || 'no especificada'}`
          break

        case 'clabe':
          this.descripcion = `CLABE ${this.data.banco_clabe || 'no especificada'}`
          break

        case 'tarjeta':
          this.descripcion = `Tarjeta ${this.data.banco_tarjeta || 'no especificada'}`
          break

        default:
          this.descripcion = ''
      }
    }
  }

  seleccionar () {
    this.onSelect({$event: {data: this.data}})
  }
}

module.component('nominasNominaDispersionPagosTransferenciasListaItem', {
  controller: NominasNominaDispersionPagosTransferenciasListaItemComponent,
  template,
  bindings: {
    admin: '<',
    data: '<',
    mostrar: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/transferencias/lista/item/component.js